import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  Button,
  TopToolbar,
  EditProps,
  BooleanInput,
} from "react-admin";
import NextLevelInput from "components/NextLevelInput";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { statusList } from "./util";
import CustomEditToolbar from "components/CustomEditToolbar";
import EditWrapper from "../../components/EditWrapper";

const LevelEdit = (props: EditProps) => {
  const param = GetParam();
  const { id } = props;

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Levels", link: `/schools/${param.get("schoolId")}/show/1` },
    { title: id, link: `` },
  ];

  const transform = async (data: any) => {
    if (!data.nextLevelId) {
      data.nextLevelId = null;
    }

    return data;
  };

  const EditActions = (props: any) => {
    const { history } = props;
    return (
      <TopToolbar>
        <Button
          onClick={() =>
            history.push(
              `/levels/${props.data?.id}/show?schoolId=${Number(
                props.data?.schoolId
              )}`
            )
          }
          label="Show"
        >
          <VisibilityIcon />
        </Button>
      </TopToolbar>
    );
  };

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        actions={<EditActions history={props.history} />}
        transform={transform}
        {...props}
      >
        <SimpleForm
          toolbar={
            <CustomEditToolbar
              redirectLink={`/schools/${param.get("schoolId")}/show/1`}
            />
          }
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">School</Typography>
            </Grid>

            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <SelectInput
                source="status"
                choices={statusList}
                validate={required()}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Next Level</Typography>
            </Grid>
            <Grid item xs={4}>
              <NextLevelInput />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Drop Off Authorization</Typography>
            </Grid>
            <Grid item xs={4}>
              <BooleanInput
                label="Enable Drop Off Authorization"
                source="dropOffAuth"
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default LevelEdit;
